(function () {
  var KEY_IDS  = 'fav_product_ids';
  var KEY_DATA = 'fav_product_data';

  function getIds() {
    try { return JSON.parse(localStorage.getItem(KEY_IDS) || '[]'); } catch (e) { return []; }
  }
  function getData() {
    try { return JSON.parse(localStorage.getItem(KEY_DATA) || '{}'); } catch (e) { return {}; }
  }
  function saveIds(ids)   { localStorage.setItem(KEY_IDS,  JSON.stringify(ids));  }
  function saveData(data) { localStorage.setItem(KEY_DATA, JSON.stringify(data)); }

  function isFav(id) {
    return getIds().indexOf(String(id)) > -1;
  }

  function addFav(id, meta) {
    var ids = getIds();
    var sid = String(id);
    if (ids.indexOf(sid) === -1) { ids.push(sid); saveIds(ids); }
    if (meta) {
      var data = getData();
      data[sid] = meta;
      saveData(data);
    }
  }

  function removeFav(id) {
    var sid = String(id);
    saveIds(getIds().filter(function (i) { return i !== sid; }));
    var data = getData();
    delete data[sid];
    saveData(data);
  }

  function toggleFav(id, meta) {
    if (isFav(id)) { removeFav(id); return false; }
    addFav(id, meta); return true;
  }

  // ── ヘッダーバッジ更新 ──────────────────────────────────
  function updateBadge() {
    var el = document.getElementById('favCount');
    if (!el) return;
    var n = getIds().length;
    el.textContent = n;
    el.classList.toggle('show', n > 0);
    var link = document.getElementById('headerFavLink');
    if (link) link.classList.toggle('fav-active', n > 0);
  }

  // ── 商品ページのお気に入りボタン更新 ───────────────────
  function updateBtn(btn, id) {
    var active = isFav(id);
    btn.classList.toggle('is-active', active);
    btn.textContent = active ? '♥ お気に入り済み' : '♡ お気に入り登録';
  }

  var toastTimer   = null;
  var lastRemoved  = null;

  function showToast(added, removedId, removedMeta) {
    var toast = document.getElementById('favToast');
    if (!toast) return;
    clearTimeout(toastTimer);

    if (added) {
      toast.innerHTML =
        '<span class="fav-toast__line1">♡ お気に入りに追加しました</span>' +
        '<a href="/pages/favorites" class="fav-toast__action">お気に入り一覧を見る ＞</a>';
    } else {
      lastRemoved = { id: removedId, meta: removedMeta };
      toast.innerHTML =
        '<span class="fav-toast__line1">♡ お気に入りから削除しました</span>' +
        '<button class="fav-toast__action" id="favToastUndo">元に戻す ＞</button>';
      var undoBtn = document.getElementById('favToastUndo');
      if (undoBtn) {
        undoBtn.addEventListener('click', function () {
          if (!lastRemoved) return;
          addFav(lastRemoved.id, lastRemoved.meta);
          updateBadge();
          var btn = document.querySelector('.btn--favorite[data-product-id]');
          if (btn && btn.dataset.productId === String(lastRemoved.id)) {
            updateBtn(btn, lastRemoved.id);
          }
          lastRemoved = null;
          toast.classList.remove('show');
          clearTimeout(toastTimer);
        });
      }
    }

    toast.classList.add('show');
    toastTimer = setTimeout(function () {
      toast.classList.remove('show');
    }, 4000);
  }

  function initBtn() {
    var btn = document.querySelector('.btn--favorite[data-product-id]');
    if (!btn) return;
    var id = btn.dataset.productId;
    updateBtn(btn, id);
    btn.addEventListener('click', function () {
      var meta = {
        handle : btn.dataset.productHandle || '',
        title  : btn.dataset.productTitle  || '',
        price  : btn.dataset.productPrice  || '',
        image  : btn.dataset.productImage  || '',
        url    : btn.dataset.productUrl    || ''
      };
      var added = toggleFav(id, meta);
      updateBtn(btn, id);
      updateBadge();
      showToast(added, id, meta);
    });
  }

  // ── お気に入りページ用 公開API ──────────────────────────
  window.FavSystem = {
    getIds     : getIds,
    getData    : getData,
    addFav     : addFav,
    removeFav  : removeFav,
    updateBadge: updateBadge
  };

  // ── ツールチップ（タッチデバイス対応）─────────────────────
  function initTooltip() {
    var wrapper = document.querySelector('.favorite-icon-wrapper');
    if (!wrapper) return;
    var tooltip = wrapper.querySelector('.favorite-tooltip');
    if (!tooltip) return;
    var visible = false;
    wrapper.addEventListener('touchstart', function (e) {
      if (!visible) {
        e.preventDefault();
        tooltip.style.opacity = '1';
        visible = true;
        setTimeout(function () {
          tooltip.style.opacity = '0';
          visible = false;
        }, 3000);
      }
    }, { passive: false });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateBadge();
    initBtn();
    initTooltip();
  });
})();
